<template>
  <div>
    <progress-bar class="progress-bar" :hidden="loading ? false : true"/>
    <div class="container-fluid">
      <div class="row mt17">
        <div class="col-lg-12 col-md-12">
          <div class="card card-nav-tabs">
            <div class="card-header gradient-merchant">
              <span
                class="title"
                style="display:inline-block"
              >{{ $t('donations.id_donation') + ' ' + route.params.id }}</span>
            </div>
            <div class="card-content">
              <div class="row">
                <div class="col-xs-8 transaction-details">
                  <div class="row">
                    <div class="col-md-6">
                      <li>{{$t('donations.amount')}}</li>
                      <p>
                        <strong>{{donationFee.amount ? donationFee.amount + ' €' : '-' }}</strong>
                      </p>
                    </div>
                    <div class="col-md-6">
                      <li>{{$t('donations.period')}}:</li>
                      <p>
                        <strong>{{ donationFee.month ? donationFee.month + '/' + donationFee.year : '-'}}</strong>
                      </p>
                    </div>
                    <div class="col-md-6">
                      <li>{{$t('donations.payments_num')}}:</li>
                      <p>
                        <strong>{{ donationFee.payments? donationFee.payments && donationFee.payments.length : '-'}}</strong>
                      </p>
                    </div>
                    <div class="col-md-6">
                      <li>{{$t('donations.number_sepa_card')}}:</li>
                      <p>
                        <strong>{{ (donationFee.method === 'sepa' ? '************************' : '**** **** **** ') + donationFee.lastDigits }}</strong>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-xs-4" style="text-align:right">
                  <p class="status">{{$t('donations.paid')}}</p>
                  <p>
                    <strong v-if="donationFee.paid === 1">
                      <span class="circleTrue" style="margin-right:10px"></span>
                      {{$t('donations.paid_ok')}}
                    </strong>
                    <strong v-if="donationFee.paid === 0">
                      <span class="circleFalse" style="margin-right:10px"></span>
                      {{$t('donations.paid_not_ok')}}
                    </strong>
                    <strong v-if="donationFee.paid === 2">
                      <span class="circleWarning" style="margin-right:10px"></span>
                      {{$t('donations.paid_waiting')}}
                    </strong>
                  </p>
                  <p class="status">{{$t('donations.processed')}}</p>
                  <p>
                    <strong v-if="donationFee.processed">
                      <span class="circleTrue" style="margin-right:10px"></span>
                      {{$t('donations.processed_ok')}}
                    </strong>
                    <strong v-if="!donationFee.processed">
                      <span class="circleFalse" style="margin-right:10px"></span>
                      {{$t('donations.processed_not_ok')}}
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <data-table
            :title="$t('donations.donations')"
            :key="componentKey"
            :tableHeaders="donationFeeDetails"
            :getData="getDonationFeeDonations"
            :options="{hasDatesFilter: false, hasSearch: false, showCardHeader: true }"
            :page="1"
            :totPages="1"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <data-table
            :title="$t('donations.payments')"
            :key="componentKey"
            :tableHeaders="tableHeaders"
            :getData="getDonationFeePayments"
            :options="{hasDatesFilter: false, hasSearch: false, showCardHeader: true }"
            :page="1"
            :totPages="1"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import apiService from '@/services/ApiService'
import DataTable from '@/components/shared/dataTable/DataTable'
import DonappButton from '@/components/shared/buttons/Button'
import ProgressBar from '@/components/shared/ProgressBar'
import { payments as detailsTable } from '@/components/merchants/tables/settings'

export default {
  name: 'donation-fee-details',
  components: {
    DataTable,
    DonappButton,
    ProgressBar
  },
  data() {
    return {
      componentKey: 0,
      loading: false,
      donationFee: {},
      issuer: {},
      refundLoading: false,
      showRefundDialog: false,
      donationFeeDetails: [
        {
          titleKey: 'name',
          key: 'name'
        },
        {
          titleKey: 'category',
          key: 'category'
        },
        {
          titleKey: 'payments',
          key: 'payments',
          getValue: row => '' + row.payments
        },
        {
          titleKey: 'amount',
          key: 'amount',
          getValue: row => row.amount + ' €'
        }
      ],
      ...detailsTable
    }
  },
  mounted: async function() {
    this.getDonationFee()
  },
  props: ['model', 'id'],
  methods: {
    getDonationFee: async function() {
      this.loading = true
      try {
        const donationFeeResult = await apiService.getDonationFee(this.id)
        this.donationFee = donationFeeResult.data.data
        this.forceRerender()
        this.loading = false
        return {
          data: {
            success: true,
            data: {
              results: [...(this.donationFee.payments || [])]
            }
          }
        }
      } catch (error) {
        this.$i18n.t('errors.something_wrong')
      }
    },
    forceRerender() {
      this.componentKey += 1
    },
    getDonationFeePayments: async function() {
      return {
        data: {
          success: true,
          data: {
            results: [...(this.donationFee.payments || [])]
          }
        }
      }
    },
    getDonationFeeDonations: async function() {
      let donations = []
      if (this.donationFee.payments) {
        const groups = this.donationFee.payments.reduce((acc, payment) => {
          if (payment.donation > 0) {
            const npoMerchant = payment.npoMerchant
            if (!payment.npo || npoMerchant._id === payment.npo._id) {
              acc[npoMerchant._id] = {
                ...npoMerchant,
                payments: acc[npoMerchant._id] ? acc[npoMerchant._id].payments + 1 : 1,
                amount: (acc[npoMerchant._id] ? acc[npoMerchant._id].amount : 0) + payment.donation
              }
            } else {
              acc[npoMerchant._id] = {
                ...npoMerchant,
                payments: acc[npoMerchant._id] ? acc[npoMerchant._id].payments + 1 : 1,
                amount: (acc[npoMerchant._id] ? acc[npoMerchant._id].amount : 0) + payment.donation - payment.donationUser
              }
              const npoUser = payment.npo || npoMerchant
              acc[npoUser._id] = {
                ...npoUser,
                payments: acc[npoUser._id] ? acc[npoUser._id].payments + 1 : 1,
                amount: (acc[npoUser._id] ? acc[npoUser._id].amount : 0) + payment.donationUser
              }
            }
          }
          return acc
        }, {})

        Object.keys(groups).map(key => {
          donations.push(groups[key])
        })
      }
      return {
        data: {
          success: true,
          data: {
            results: donations
          }
        }
      }
    }
  },
  computed: {
    donationFeeAmount: function() {
      return this.donationFee.amount ? this.donationFee.amount + ' €' : '-'
    },
    donationFeePeriod: function() {
      return this.donationFee.month ? this.donationFee.month + '/' + this.donationFee.year : '-'
    },
    donationFeePaymentsNum: function() {
      return this.donationFee.payments ? this.donationFee.payments && this.donationFee.payments.length : '-'
    },
    donationFeeLastDigits: function() {
      if (this.donationFee.method) {
        return (this.donationFee.method === 'sepa' ? '************************' : '**** **** **** ') + this.donationFee.lastDigits
      } else return '-'
    },
    ...mapState({
      route: state => state.route
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../../scss/config.scss';

.circleTrue,
.circleFalse,
.circleWarning {
  margin: 2px 1px 0px 5px;
}

.i-b {
  display: inline-block;
}

li {
  list-style: none;
}

.issuer span.selected {
  color: #202020;
  font-weight: bold;
}

.issuer p {
  color: rgba(0, 0, 0, 0.2);
  font-weight: regular;
}

p.value {
  color: #202020;
  font-weight: bold;
}

.bank-details p {
  margin: 0px;
}

.status {
  margin: 0px;
}

.fraud {
  margin: 0px;
}

p.url {
  color: #0366d6;
}

p.tel {
  color: #202020;
}

.header-action {
  margin: auto;
  color: white;
}

.card .title {
  color: $white;
  @include normalFontSize();
  line-height: 14px;
  margin-right: 8px;
  font-weight: normal;
}

.card.card-acquirer,
.card.card-issuer {
  min-height: 190px;
}
</style>



// WEBPACK FOOTER //
// src/components/merchants/DonationFeeDetails.vue